import AnalyticsSummaryList from "./analytics-summary-list";

export default AnalyticsSummaryList;